export default __webpack_public_path__ + "fonts/h5-footer-qrcode.8a346df599507c039cdf82739488c580.png";